<template xmlns:href="http://www.w3.org/1999/xhtml">
  <div id="app" >
     <div class="header">
      <div class="logoHeader">
        <router-link to="/">
          <img class="logoHome" src="@/assets/Logo.png" />
        </router-link>
      </div>
      <!-- <div class="titleDiv"> -->
        <h1 class="headerTitle">Crevadan Design</h1>
      <!-- </div> -->
      <div>
        <p class="icon">
          <a href="mailto:crevadan@hotmail.fr">
            <i class="w fas fa-envelope" />
          </a>
        </p>
        <p class="icon">
          <a href="https://www.instagram.com/crevadandesign/" target="_blank">
            <i class=" w fab fa-instagram" />
          </a>
        </p>
      </div>
      <div class="linkContainer">
        <div class="headerLinks">
          <router-link class="link" to="/">Accueil</router-link>
          <router-link class="link" to="/studios">Studios</router-link>
          <router-link class="link" to="/renovations">Rénovations</router-link>
          <router-link class="link" to="/mobilier">Mobilier</router-link>
        </div>
      </div>
    </div>
    <router-view />
    <div class="footer">
      <div>Crevadan design</div>
      <div>4 rue Louise Michel, 95190 Goussainville  -  <a class="mail" href="mailto:crevadan@hotmail.fr">crevadan@hotmail.fr</a>  -  <a class="tel" href="tel:+33630869689">06 30 86 96 89</a> </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@font-face {
  font-family: "Audrey";
  src: local("Audrey"), url("./font/Audrey-Normal.otf");
}
#app {
  font-family: "Audrey";
}
.maintenance {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.fa-envelope,
.fa-instagram {
  color: white;
}
.text {
  font-family: "Audrey";
  font-size: 60px;
  color: white;
}

body {
  color: white;
  margin: 0;
  padding: 0;
  background-color: black;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.header .headerTitle {
  margin: auto;
  padding-right: 220px;
  font-size: 5em;
}
.header .titleDiv {
  width: 70%;
  text-align: center;
}
.header,
.footer {
  text-align: initial;
}

.header {
  margin: 0 150px 50px 150px;
  display: flex;
  flex-wrap: wrap;
}
.logoHeader {
  margin-top: 15px;
}
.headerLinks a,
.mail,
.tel {
  color: white;
}
.headerLinks .router-link-active {
  text-decoration: underline;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px 0;
}
.footer div {
  margin: 6px;
}

.header .logoHome {
  width: 220px;
  background-color: white;
}
.header .link {
  font-size: large;
  text-decoration: none;
  margin: 0 50px;
  padding: 15px 15px 0 15px;
}
.share-fb img {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 150px;
}
.icon .b {
  color: black;
}
.titleTile {
  margin-bottom: 50px;
  margin-top: 30px;
}
.titleTile:first-child {
  margin-top: 0px;
}
.icon {
  font-size: x-large;
}
.linkContainer {
  width: 100%;
  text-align: center;
}
@media screen and (max-width: 1060px) {
  body {
    margin: 0;
  }
  .header .link {
    margin: 10px 50px;
  }
  .headerLinks {
    margin-left: 20px;
  }
}
@media screen and (max-width: 1425px) and (min-width: 1061px) {
  .header {
    margin: 0 50px 50px 50px;
    display: flex;
    flex-wrap: wrap;
  }
  .linkContainer {
    padding-top: 50px;
  }
  .header .link {
    margin-left: 70px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .header {
    margin-bottom: 10px;
  }
  .header .titleDiv {
    width: 61%;
  }
  .header .logoHome {
    width: 100px;
  }
  .footer {
    padding: 0 10px;
  }
  .header .link {
    margin: 7px;
    padding: 0;
  }
  .headerLinks {
    margin-top: 15px;
  }
  .header .headerTitle {
    margin-top: 30px;
  }
  .trustLogo {
    width: 70%;
  }
  .innerSpan {
    width: 150px;
  }
}
</style>
